import { ConfigBase } from "../packages/base/config/index.js";

//#region src/config/index.ts
const config = new ConfigBase((env) => {
	const cookiePrefix = "jw_";
	const cookieSuffix = env === "prd" ? "" : `_${env}`;
	return {
		env,
		auth: {
			fromAdminQueryParam: "auth-from-admin",
			tokenTtl: {
				stale: 5760 * 60 * 1e3,
				expired: 4.9 * 24 * 60 * 60 * 1e3
			},
			cookies: {
				token: `${cookiePrefix}auth_gateway${cookieSuffix}`,
				mfa: {
					identifier: `${cookiePrefix}auth_gateway_mfa${cookieSuffix}`,
					ttl: 3600 * 24 * 14
				},
				authFromAdmin: `${cookiePrefix}auth_gateway_from_admin${cookieSuffix}`,
				activeSiteId: `${cookiePrefix}active_site_id${cookieSuffix}`
			}
		},
		urls: {
			apiGateway: "",
			contentServer: ""
		},
		upload: {
			direct: { maxSize: 100 * 1e3 ** 2 },
			multipart: {
				maxRetries: 3,
				timeBetweenRetries: 3e3,
				partSize: 10 * 1e3 ** 2,
				maxConcurrentParts: 3
			}
		}
	};
});

//#endregion
export { config };